// client/src/routes/app/tenants/$tenantId/documents.tsx — SCR-TEN-002 tab „Documente" · D-2866.

import { createFileRoute } from '@tanstack/react-router';

import { DocumentsTab } from '@/features/tenants/DocumentsTab';

export const Route = createFileRoute('/app/tenants/$tenantId/documents')({
  component: DocumentsTabScreen,
});

function DocumentsTabScreen() {
  const { tenantId } = Route.useParams();
  return <DocumentsTab tenantId={tenantId} />;
}
